import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["className"],
    _excluded2 = ["separator", "container", "className"],
    _excluded3 = ["counter"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from 'react';
import { useLightboxState, clsx, cssClass, createModule } from '../../index.js';
import { MODULE_CONTROLLER, PLUGIN_COUNTER } from '../../types.js';
var defaultCounterProps = {
  separator: "/",
  container: {}
};

var resolveCounterProps = function resolveCounterProps(counter) {
  return _objectSpread(_objectSpread({}, defaultCounterProps), counter);
};

function CounterComponent(_ref) {
  var counter = _ref.counter;

  var _useLightboxState = useLightboxState(),
      slides = _useLightboxState.slides,
      currentIndex = _useLightboxState.currentIndex;

  var _resolveCounterProps = resolveCounterProps(counter),
      separator = _resolveCounterProps.separator,
      _resolveCounterProps$ = _resolveCounterProps.container,
      className = _resolveCounterProps$.className,
      rest = _objectWithoutProperties(_resolveCounterProps$, _excluded),
      legacyClassName = _resolveCounterProps.className,
      legacyRest = _objectWithoutProperties(_resolveCounterProps, _excluded2);

  if (slides.length === 0) return null;
  return React.createElement("div", _objectSpread(_objectSpread({
    className: clsx(cssClass("counter"), className || legacyClassName)
  }, legacyRest), rest), currentIndex + 1, " ", separator, " ", slides.length);
}

function Counter(_ref2) {
  var augment = _ref2.augment,
      addChild = _ref2.addChild;
  augment(function (_ref3) {
    var counter = _ref3.counter,
        restProps = _objectWithoutProperties(_ref3, _excluded3);

    return _objectSpread({
      counter: resolveCounterProps(counter)
    }, restProps);
  });
  addChild(MODULE_CONTROLLER, createModule(PLUGIN_COUNTER, CounterComponent));
}

export { Counter as default };